import React from "react";
import SearchSelect from "./SearchSelect";

const Content = () => {

    return(
        <div className="main">
            <p className="title">Bring your Data to Life</p>
            <div className="description">
                Select the data sources you use to store your customer data
            </div>

            <SearchSelect placeholder="Where do you store your customer data?"/>
        </div>
    )
}

export default Content;
